module.exports = __webpack_public_path__ + "img/ai.f04e201c.gif";